import {
  BountyIntroChannel, BountyIntroContact,
  ClaimBountyResponseDto, GetBountiesResponseDto,
  ProposeBountyRequestDto, ProposeBountyResponseDto, SubmitBountyIntroResponseDto,
  UpdateBountyProposalRequestDto, UpdateBountyProposalResponseDto,
} from '@foodfluence/shared';
import { apiRequest } from './apiUtils';

export const bountyApi = {
  getBounties: async (influencerId: string): Promise<GetBountiesResponseDto> => {
    return apiRequest({ method: 'GET', endpoint: '/bounties', influencerId });
  },

  proposeBounty: async (
    influencerId: string,
    params: Omit<ProposeBountyRequestDto, 'influencerId'>
  ): Promise<ProposeBountyResponseDto> => {
    return apiRequest({
      method: 'POST', endpoint: '/bounties/propose',
      data: { influencerId, ...params }, influencerId,
    });
  },

  updateProposal: async (
    influencerId: string,
    proposalId: string,
    params: Omit<UpdateBountyProposalRequestDto, 'influencerId'>
  ): Promise<UpdateBountyProposalResponseDto> => {
    return apiRequest({
      method: 'PATCH', endpoint: `/bounties/proposals/${proposalId}`,
      data: { influencerId, ...params }, influencerId,
    });
  },

  claimBounty: async (influencerId: string, bountyId: string): Promise<ClaimBountyResponseDto> => {
    return apiRequest({
      method: 'POST', endpoint: `/bounties/${bountyId}/claim`,
      data: { influencerId }, influencerId,
    });
  },

  submitIntro: async (
    influencerId: string,
    claimId: string,
    params: { channel: BountyIntroChannel; contact: BountyIntroContact; note?: string }
  ): Promise<SubmitBountyIntroResponseDto> => {
    return apiRequest({
      method: 'POST', endpoint: `/bounties/claims/${claimId}/intro`,
      data: { influencerId, ...params }, influencerId,
    });
  },
};
